import { smoothScroll, getParams, updateQueryStringParam } from './utils/utils'
import Blazy from 'blazy'
import gsap from 'gsap'
import inView from 'in-view'
import Flickity from 'flickity'
import Cookies from 'js-cookie'

const HTML = document.querySelector('html');

class App {

	constructor() {
		console.log(`${this.constructor.name}:constructor`)

		// Prevent scrollTop on click on a[href="#"] links
		let linksEmpty = document.querySelectorAll('a[href="#"]');
		if( linksEmpty ) linksEmpty.forEach((el) => { el.addEventListener('click', function(e) { e.preventDefault(); }) });

		// Smooth scroll for anchors link
		let linksAnchor = document.querySelectorAll('a[href*="#"]:not([href="#"])');
		if( linksAnchor ) linksAnchor.forEach((el) => { el.addEventListener('click', smoothScroll) });

		// Check if mac for better font aliasing
		if (navigator.platform === 'MacIntel' || navigator.platform === 'MacPPC') HTML.classList.add('is-mac')

		// Menu toggle
		let toggle = document.querySelector('.menu-toggle');
		if( toggle ) {
			toggle.addEventListener('click', (e) => {
				e.preventDefault();

				HTML.classList.toggle('open-menu');
			})
		}
		// Menu toggle submenu
		let toggleSub = document.querySelector('.toggle-submenu');
		if( toggleSub ) {
			toggleSub.addEventListener('click', (e) => {
				e.preventDefault();

				HTML.classList.toggle('open-submenu');

				document.body.removeEventListener('click', close)
				document.body.addEventListener('click', close)

				function close(e) {
					if( !e.target.classList.contains('menu--sidebar-account') && !e.target.closest('.menu--sidebar-account') ) {
						HTML.classList.remove('open-submenu');
						e.stopPropagation()
						document.body.removeEventListener('click', close)
					}
				}
			})
		}

		// Blazy
		this.blazy = new Blazy({
			breakpoints: [{
      	width: 420,
				src: 'data-src-small'
     	}],
	    selector : '.js-lazy',
	    success : function(elt) {
	    	if( elt.closest('figure') )
	    		elt.closest('figure').classList.add('img-is-loaded')
	    }
		});

		// Carousel project
		let projects = document.querySelectorAll('.project-carousel');
		if( projects ) {
			projects.forEach(el => {
				new Flickity( el, {
					cellSelector: '[class*="grid__col-"]',
					cellAlign: 'left',
					contain: true,
					pageDots: false,
				})
			})
		}

		inView.offset(window.innerHeight * .1);
		inView('.js-reveal:not(.is-visible)')
    	.on('enter', function(elt) {
    		elt.classList.add('is-visible');

    		elt.dispatchEvent(new Event('inviewport'))
			})

			// Build slider product
			let productSlider = document.querySelectorAll('.product__slider');
			if( productSlider ) {
				productSlider.forEach(slider => {
					new Flickity( slider, {
						cellAlign: 'left',
						wrapAround: true,
						lazyLoad: 6,
						pageDots: false,
						on : {
							dragStart : () => {
								slider.classList.add('on-move')
							},
							dragEnd : () => {
								setTimeout(() => {
									slider.classList.remove('on-move')
								}, 300)
							}
						}
					});

					if( slider.querySelectorAll('.product__slider--item').length <= 6 && window.innerWidth >  992 ) {
						// slider.classList.add('noslider')
					}
				})
			}

		let funnel = document.querySelector('.funnel');
		if( funnel ) {
			this.funnel(funnel);
		}

		// Build input type number
		// let numbers = document.querySelectorAll('.form__number');
		// if( numbers ) {
		// 	numbers.forEach((el) => {
		// 		let less = el.querySelector('.less')
		// 		let more = el.querySelector('.more')
		// 		let input = el.querySelector('input')

		// 		less.addEventListener('click', qtyModify)
		// 		more.addEventListener('click', qtyModify)

		// 		function qtyModify(e) {
		// 			e.preventDefault();

		// 			if( e.target.classList.contains('less') ) {
		// 				if( input.getAttribute('min') != null && input.getAttribute('min') >= input.value) return false;
		// 				input.value = parseInt(input.value) - 1;
		// 			} else {
		// 				if( input.getAttribute('max') != null && input.getAttribute('max') <= input.value) return false;
		// 				input.value = parseInt(input.value) + 1;
		// 			}
		// 		}
		// 	})
		// }
		// jQuery('.form__number').on('click', 'a', (e) => {
		// 	e.preventDefault();
		// 	let input = jQuery(e.target).parent().find('input')[0];

		// 	if( e.target.classList.contains('less') ) {
		// 		if( input.getAttribute('min') != null && input.getAttribute('min') >= input.value) return false;
		// 		input.value = parseInt(input.value) - 1;
		// 	} else {
		// 		if( input.getAttribute('max') != null && input.getAttribute('max') <= input.value) return false;
		// 		input.value = parseInt(input.value) + 1;
		// 	}

		// 	jQuery(input).trigger('change');
		// })

		return this
	}

	/**
	 * Init the page
	 * @return {object} The current instance
	 */
	init() {
		console.log(`${this.constructor.name} is init`)

		return this;
	}

	funnel(elt) {
    let current = -1;
    let pos = 0;
    let step = elt.querySelectorAll('.funnel__step')
    let items = elt.querySelectorAll('.funnel__step--item')
    let navContainer = elt.querySelector('.funnel__nav ul')
    let nav = navContainer.querySelectorAll('li')
    let breadcrumb = elt.querySelector('.funnel__breadcrumb ul')
    let cursor = elt.querySelector('.cursor')
    let desgin = elt.querySelector('[data-step="design"]')
    let combo = elt.classList.contains('funnel--combo')
    let comboProjectId = null

		//
    if( combo ) {
      updateQueryStringParam('sport', elt.dataset.sportId);
      updateQueryStringParam('cut', elt.dataset.cutId);
      comboProjectId = elt.dataset.projectId;
    }

    let paramsGet = getParams(window.location.href);
    if( paramsGet ) {
			Object.keys(paramsGet).map((key, i) => {
				// Active elements
				let item = elt.querySelector(`.funnel__step--item[data-${key}-id="${paramsGet[key]}"]`)
				if( item ) {
					item.classList.add('active');

					// Go to the good step
					if( i == Object.keys(paramsGet).length - 1) {
						let parent = item.closest('.funnel__step')
						goto([...parent.parentElement.children].indexOf(parent) + 1);
					}
				}
			})
		}
    else{
      goto(0);
    }





		// Active slider products
		let products =  elt.querySelectorAll('.products')
		if( products ) {
			products.forEach(p => {
				new Flickity(p, {
					watchCSS: true,
					pageDots: false,
					cellAlign: 'center',
					wrapAround: true,
					prevNextButtons: false
				})
			})
		}

		items.forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				// Update url parameters
				for( var key in item.dataset) {
					if( key.indexOf('Id') >= 0 ) {
						updateQueryStringParam(key.replace('Id', ''), item.dataset[key]);
					}
				}

				let index = [...step[current].parentElement.children].indexOf(step[current]);
				let next = index + 1;
				item.classList.add('active');

				window.dispatchEvent(new Event('resize'));

				goto(next);
			})
		})

		function goto(next) {
			let dir = ( next > current ) ? 1 : -1;

			// Clear current and next active choice
			for( var i = current; i >= next; i-- ) {
				let oldActiveItems = step[i].querySelectorAll('.funnel__step--item.active');

				if( oldActiveItems ) {
					oldActiveItems.forEach( el => { el.classList.remove('active') })
				}
			}

			// Active the good choice
			let activeItems = document.querySelectorAll('.funnel__step--item.active');
			breadcrumb.innerHTML = '';

			if( activeItems ) {
				let selectorItems = [];

				activeItems.forEach( el => {
					let li = document.createElement('li');

					if( el.dataset.sportId) {
						Cookies.set('sport_selected', el.dataset.sportId);
						document.cookie = "username=John Doe";
						selectorItems.push(`[data-sport-id="${el.dataset.sportId}"]`)
						li.dataset.sportId = el.dataset.sportId;
					} else if( el.dataset.cutId) {
						selectorItems.push(`[data-cut-id="${el.dataset.cutId}"]`)
						li.dataset.cutId = el.dataset.cutId;
					}  else if( el.dataset.performanceId) {
						selectorItems.push(`[data-performance-id="${el.dataset.performanceId}"]`)
						li.dataset.performanceId = el.dataset.performanceId;
					} else if( el.dataset.productId ) {
						li.dataset.productId = el.dataset.productId;

						// On construit le bon slider
						const slider = document.querySelector(`.product__slider`);
						const designs = drupalSettings.defil_adv_func.designs[el.dataset.productId];
						const flkty = Flickity.data(slider);
						if( slider && designs && flkty ) {
							// Remove old element
							const slides = slider.querySelectorAll('.product__slider--item');
							if( slides ) {
								flkty.remove(slides)
							}

							designs.forEach(design => {
								const a = document.createElement('a');
								a.classList.add('product__slider--item');
								a.href = `${slider.dataset.url.replace('/1', `/${el.dataset.productId}?`)}design=${design.code}` + (combo ? '&combo_id=' + comboProjectId : '');

								const img = document.createElement('img');
								img.setAttribute('data-flickity-lazyload', design.previewPath);
								a.append(img);

								const span = document.createElement('span');
								span.innerHTML = design.label + `<br><small>${design.description != null ? design.description : ''}</small>`;
								a.append(span)

								flkty.append(a);
							})
						}

						// On affiche le bon slider
						// let sliderActive = document.querySelector(`.product__slider.active`)
						// if( sliderActive ) {
						// 	sliderActive.classList.remove('active');
						// }
						// let sliderType = document.querySelector(`.product__slider[data-slider="${el.dataset.productType}"]`)
						// if( sliderType ) {
						// 	sliderType.classList.add('active');
						// }

						// On construit le contenu en fonction de ce qu'il a sélectionné
						let content = '';
						let sport = el.querySelector('.product--sport');
						if( sport ) content += `<h5>${sport.innerHTML}</h5>`;

						let title = el.querySelector('.product--title');
						if( title ) content += `<h4>${title.innerHTML}</h4>`;

						let price = el.querySelector('.product--price');
						if( price ) content += `<div class="product--price">${price.innerHTML}</div>`;

						// Update teaser product content
						desgin.querySelector('.product__teaser--info .changing').innerHTML = content;

						// Update teaser product img
						let img = el.querySelector('.product--img img')
						if( img ) desgin.querySelector('.product__teaser--img img').src = img.src;

						// Update url
						let links = desgin.querySelectorAll('a[data-url]');
						if( links ) {
							links.forEach(link => {
								// link.removeEventListener('click', linkConfigurator)
								// link.addEventListener('click', linkConfigurator)

								link.href = link.dataset.url.replace('/1?', `/${el.dataset.productId}?design=${designs[0].code}`) + (combo ? '&combo_id=' + comboProjectId : '')
							})

							function linkConfigurator(e) {
								e.preventDefault();
								let lin = e.target.nodeName == 'A' ? e.target : e.target.closest('a');

								window.location.href = lin.dataset.url.replace('/1?', `/${el.dataset.productId}?`)
							}
						}
					}

					// Update breadcrumb
					li.innerHTML = el.querySelector('.title').innerHTML;
					li.addEventListener('click', (e) => {
						e.preventDefault();

						let i = [...li.parentElement.children].indexOf(li);
						if( i == current ) return;

						for( var key in li.dataset) {
							if( key.indexOf('Id') >= 0 ) {

								updateQueryStringParam(key.replace('Id', ''), '');
							}
						}

						goto(i);
					})
					breadcrumb.append(li);
				})



				let activeChoice = document.querySelector(`.funnel__step--items${selectorItems.join('')}`)
				if( activeChoice )
					activeChoice.classList.add('active');
			}

			// Move step
			if( current >= 0 ) {
				gsap.to(step[current], { duration : 0.7, x : -100 * dir + '%', ease: "circ.inOut" })
				step[current].classList.remove('active-step')
			}

			step[next].classList.add('active-step')
			gsap.fromTo(step[next], { x : 100 * dir + '%' }, { duration : 0.7, x : '0%', ease: "circ.inOut", onComplete : () => {
				for( var i = current + 1; i < step.length; i++ ) {
					let oldActiveChoice = step[i].querySelectorAll('.funnel__step--items.active');

					if( oldActiveChoice ) {
						oldActiveChoice.forEach( el => { el.classList.remove('active') })
					}
				}
			}})

			// Move breadcrumb
			pos = -1 * (nav[next].getBoundingClientRect().left - window.innerWidth / 2 - pos + nav[next].offsetWidth / 2);
			gsap.to(navContainer, { duration : 0.4, x : pos });

			// Move cursor nav
			if( current >= 0 ) nav[current].classList.remove('active')
			nav[next].classList.add('active')
			let x = nav[next].getBoundingClientRect().left - nav[next].parentNode.getBoundingClientRect().left;
			gsap.to(cursor, { duration : 0.4, x : x, width : nav[next].offsetWidth })


			current = next;

		}


		// Nav nav
		nav.forEach( (link, i) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				if( i > current ) return;

				goto(i)
			})
		})
	}
}


document.addEventListener("DOMContentLoaded", function() {
	new App();
});

document.addEventListener("load", function() {
	window.dispatchEvent(new Event('resize'));
});
